import type { ContextKey } from "../../../skills/leadcue-reply/scripts/lib/context-contracts.ts";

/**
 * A saved fact as a rep would name it: in the withheld card, for the checks that stop on a missing
 * one, and in a question the engine raised about saved context (`context-question-words.ts`).
 */
export const FACT_NAMES: Readonly<Record<ContextKey, string>> = {
  campaign_goal: "the campaign’s goal",
  next_step_policy: "the next step this campaign allows",
  recipient_timezone: "the lead’s time zone",
  rep_timezone: "your time zone",
  seller_name: "the seller’s name",
  seller_identity: "who the seller is",
  seller_offer: "what you offer",
  language: "the language to write in",
  prospect_name: "the lead’s name",
  rep_name: "your name",
  meeting_duration_minutes: "how long the call is",
  event: "the event’s details",
  scheduling_policy: "when calls can be booked",
  availability: "when you are free",
  calendar_mode: "how this campaign books",
  booking_context: "whether a call is booked",
  approved_facts: "a fact about your offer",
  seller_resources: "the material you send",
  reply_guards: "what a reply must not say",
  answers_when_asked: "a saved answer",
  meeting_hours: "your meeting hours",
  tone_preferences: "the tone to write in",
  approved_examples: "an example reply",
  feedback: "your earlier feedback",
  commitments: "an open promise",
  follow_up_promises: "a follow-up you promised",
  qualification_context: "whether this lead qualifies",
};
